import BillTable from 'components/shared/Table/BillTable';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getBills } from 'store/Writer/BillDisplay/actions';
import { BillDisplaySelector } from 'store/Writer/BillDisplay/reducers';
import { BILL_COMLUMNS } from 'utils/Constants';

function WriterFacutarionPage() {
  const columns = BILL_COMLUMNS;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bills, status } = useSelector(BillDisplaySelector);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
  }, []);

  useEffect(() => {
    dispatch(getBills());
  }, [dispatch]);

  return (
    <>
      <BillTable
        title={t('Mes Factures')}
        columns={columns}
        bills={bills}
        isLoading={status === 'succeeded' ? false : true}
      />
    </>
  );
}

export default WriterFacutarionPage;
